import type { IKnapCurrentUserDTO } from 'src/app/auth/domain/contracts/knap-current-user'
import type { OAuthProvider } from 'src/app/auth/domain/models/oauth-provider'
import type { User } from 'src/app/auth/domain/models/user'

export interface IMapKnapUserParams {
  dto: IKnapCurrentUserDTO
}

const KNOWN_PROVIDERS: ReadonlySet<string> = new Set(['google', 'microsoft'])

const toProvider = (value: string | null): OAuthProvider | null => {
  if (value === null) return null
  return KNOWN_PROVIDERS.has(value) ? (value as OAuthProvider) : null
}

export const mapKnapUser = (params: IMapKnapUserParams): User => {
  const { dto } = params
  return {
    id: String(dto.id),
    uuid: dto.uuid,
    email: dto.email,
    name: dto.name,
    avatarUrl: dto.profile_image_url,
    provider: toProvider(dto.provider),
    timezone: dto.timezone,
    preferredLanguage: dto.preferred_language,
    isBetaTester: dto.is_beta_tester,
    isSuperAdmin: Boolean(dto.is_super_admin),
  }
}
